import { useApp } from '../state/AppContext.js';
import type { RouteKey } from '../state/router.js';
import type { IconName } from '../icons/registry.js';
import { Icon } from '../icons/Icon.js';
import { SidebarFooter } from './SidebarFooter.js';

type NavItem = { key: RouteKey; label: string; icon: IconName; wip?: string };
type NavGroup = { group: string | null; items: NavItem[] };

const NAV: NavGroup[] = [
  { group: null, items: [
    { key: 'experience', label: '首页',     icon: 'compass' },
    { key: 'history',    label: '任务管理', icon: 'list' },
  ]},
  { group: '替换', items: [
    { key: 'object',     label: '物体替换', icon: 'object' },
    { key: 'scene',      label: '场景替换', icon: 'image' },
    { key: 'person',     label: '人物替换', icon: 'user' },
  ]},
  { group: '创作（开发中）', items: [
    { key: 'viral',      label: '爆款拆解', icon: 'telescope', wip: '开发中' },
    { key: 'storyboard', label: '分镜脚本', icon: 'grid',      wip: '开发中' },
    { key: 'video',      label: '视频生成', icon: 'video',     wip: '开发中' },
  ]},
  { group: '系统', items: [
    { key: 'assets',     label: '资源库',   icon: 'folder' },
    { key: 'settings',   label: '设置',     icon: 'settings' },
  ]},
];

export function Sidebar() {
  const { state, actions } = useApp();
  return (
    <aside className="sidebar">
      <div className="sidebar-content">
        <div className="sidebar-header">
          <div className="brand-logo">
            <Icon name="video" size={15} />
          </div>
          <span className="brand-name">AI 视频创作</span>
          <button
            type="button"
            className="collapse-btn"
            onClick={actions.toggleCollapsed}
            title={state.collapsed ? '展开侧栏' : '收起侧栏'}
          >
            <Icon name="collapse" size={18} />
          </button>
        </div>

        {NAV.map((sec, i) => (
          <div className="nav-section" key={sec.group ?? `_${i}`}>
            {sec.group && <div className="nav-label">{sec.group}</div>}
            {sec.items.map((it) => {
              const active = state.route === it.key;
              return (
                <div
                  key={it.key}
                  role="button"
                  tabIndex={0}
                  className={
                    'nav-item' +
                    (active ? ' active' : '') +
                    (it.wip ? ' wip' : '')
                  }
                  onClick={() => actions.navigate(it.key)}
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') actions.navigate(it.key); }}
                  title={it.label + (it.wip ? ' · ' + it.wip : '')}
                >
                  <Icon name={it.icon} size={18} />
                  <span className="nav-item-label">{it.label}</span>
                  {it.wip && <span className="nav-wip">{it.wip}</span>}
                </div>
              );
            })}
          </div>
        ))}
      </div>
      <SidebarFooter />
    </aside>
  );
}
